import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConnectionService } from '../../shared/services/Connection/connection.service';
import { CacheService } from '../../shared/services/Cache/cache.service';
import { Company } from 'src/app/shared/Interfaces/company';

@Injectable({
  providedIn: 'root',
})

export class ConnectionGuard implements CanActivate {
  company!: Company;
  
  constructor( private router: Router, private connection: ConnectionService, private cacheService: CacheService ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const fullUrl = state.url;
    const [_, nameCompany] = fullUrl.split('/');
    const cacheCounter = this.cacheService.getItemLocalTimeout('counter_key')
    let counter;
    if(cacheCounter){
      counter = cacheCounter;
    }


    const type = (counter) ? {
        type: 3,
        qrCodeNumber: counter.data,
        numberParam: 0
    } : {
        type: 0,
        qrCodeNumber: 0,
        numberParam: 0
    };
      
    this.connection.updateType(type);
    
    this.connection.getCompany(nameCompany, type.type).subscribe((data) => {});

    return true
  }

}
